// Geist (fonte do Design System) nos mesmos pesos que o tema usa do Roboto.
import '@fontsource/geist/300.css';
import '@fontsource/geist/400.css';
import '@fontsource/geist/500.css';
import '@fontsource/geist/700.css';
import logo from '../../../assets/beworks-logo.png';
import logoWhite from '../../../assets/beworks-logo-white.png';

/**
 * Marca Beworks (padrão). Cores do Beworks Design System (#790):
 * - Azul Beworks #213053 → primary.main
 * - Laranja destaque #F86035 → secondary.main
 * - Fundo #F3F6FC → background.default (do mockup das páginas internas)
 * - AppBar do dashboard #EBF2FF → dashboardAppBar.main (nas outras marcas é o
 *   primary). Fundo claro: o useBrand troca o logo da barra pelo colorido.
 * - Fonte Geist → typography.fontFamily. Por enquanto só a família muda (#791):
 *   tamanhos e pesos continuam os padrões do MUI.
 *
 * Só o `main` é definido: light, dark e contrastText vêm do MUI (augmentColor,
 * tonalOffset 0.2, contrastThreshold 3). Valores que ele calcula no light:
 *
 *               main      light     dark      contrastText
 *   primary     #8553F4   #9D75F6   #5D3AAA   #fff (13:1)
 *   secondary   #FF7847   #FF936B   #B25431   #fff (2.62:1, fixo na marca)
 *

 * (Referência: se mudar um `main`, esses valores mudam junto.)
 *
 * O "Azul-escuro" #303544 do design não entra como primary.dark: é mais claro
 * que o main, e no MUI o dark é o tom mais escuro (hover dos botões).
 *
 * Dark: o design ainda não tem valores para o esquema escuro (#874). O primary
 * é o `light` do roxo do light (#9D75F6, 5,65:1 sobre o fundo #121212), com
 * texto branco (3,31:1, o MUI também escolhe branco); o secondary repete o
 * laranja e a exceção do texto branco. Os fundos continuam os padrões do MUI.
 */
const beworks = {
  name: 'Beworks',
  logo: { light: logo, dark: logoWhite },
  themeOptions: {
    typography: {
      fontFamily: '"Geist", sans-serif',
    },
    colorSchemes: {
      light: {
        palette: {
          primary: {
            main: '#8553F4'
            // main: '#6D3AF5'
          },
          secondary: {
            main: '#FF7847',
            // Exceção à regra do MUI: com contrastThreshold 3 ele escolheria texto
            // preto (o branco tem 2,62:1 sobre #FF7847), mas o brand book usa
            // texto branco sobre esse laranja. Contraste abaixo do mínimo do WCAG
            // (3:1 para texto grande e ícones), aceito por decisão de marca (#874).
            contrastText: '#ffffff',
          },
          background: { default: '#F3F6FC' },
          dashboardAppBar: { main: '#EBF2FF' },
        },
      },
      dark: {
        palette: {
          // Tom mais claro do roxo do light, para ler sobre o fundo escuro.
          primary: { main: '#9D75F6' },
          // Mesmo laranja e mesma exceção do texto branco do light.
          secondary: { main: '#FF7847', contrastText: '#ffffff' },
          // Fundos do dark do design: bons no dashboard, não no mobile; aguardam o
          // design (#874).
          // background: { default: '#12161F', paper: '#1E2430' },
        },
      },
    },
  },
};

export default beworks;
